module.exports = __webpack_public_path__ + "static/media/MapMarker.377f67d1.svg";